import { parseTemplateVariable } from 'utils/templateVariableParsing';
import { hasDisplayableVariableValue } from 'utils/variableValuePrimitives';
import { lookupTemplateVariableValue } from 'utils/variableValueLookup';

/** Replace `{{variable}}` placeholders with resolved job attribute values. */
export const fillTemplateVariables = (
  text: string,
  variableValues: Record<string, string> | null | undefined
): string => {
  if (!text) {
    return text;
  }

  return text.replace(/\{\{([^{}]+)\}\}/g, (match, varName: string) => {
    // Walk the `or` operands left-to-right, mirroring the backend eval: the first quoted literal
    // renders as-is and short-circuits; a variable operand renders when its resolved value is
    // non-empty, else we continue. If nothing resolves, keep the raw placeholder (the same
    // unresolved-head behavior as a plain `{{name}}` with no value and no fallback).
    const { alternatives } = parseTemplateVariable(varName);
    for (const operand of alternatives) {
      if (operand.kind === 'literal') {
        return operand.value;
      }
      const value = lookupTemplateVariableValue(operand.name, variableValues);
      if (hasDisplayableVariableValue(value)) {
        return value;
      }
    }
    // Mirror the backend's known-empty collapse (replace_template_variables_from_mapping): when a
    // live operand is present-but-empty, the placeholder renders blank rather than leaking raw
    // braces, so the preview matches what send-time actually produces.
    for (const operand of alternatives) {
      if (
        operand.kind !== 'literal' &&
        lookupTemplateVariableValue(operand.name, variableValues) === ''
      ) {
        return '';
      }
    }
    return match;
  });
};
